export const kitchenRenoMaterials = [
  {
    groupName: 'Demolition & Prep Materials',
    materials: [
      { intent: 'Plastic sheeting (for dust containment)', quantity: 1 },
      { intent: 'Floor protection (Ram Board, drop cloths)', quantity: 1 },
      { intent: 'Heavy-duty contractor trash bags', quantity: 1 },
      { intent: 'Debris bin / haul-away service', quantity: 1 },
      { intent: 'Temporary wall zip poles or magnetic door seals (optional)', quantity: 1 }
    ]
  },
  {
    groupName: 'Plumbing Supplies',
    materials: [
      { intent: 'New supply lines (PEX, copper, or CPVC per code)', quantity: 1 },
      { intent: 'Fittings (elbows, couplings, tees)', quantity: 1 },
      { intent: 'Shut-off valves (angle stops for sink, dishwasher, fridge)', quantity: 1 },
      { intent: 'Sink drain and P-trap assembly', quantity: 1 },
      { intent: 'Air admittance valve (if allowed/needed)', quantity: 1 },
      { intent: 'Dishwasher drain connection kit', quantity: 1 }
    ]
  },
  {
    groupName: 'Electrical Materials',
    materials: [
      { intent: 'GFCI outlets (as required by code)', quantity: 1 },
      { intent: 'Standard outlets and USB outlets', quantity: 1 },
      { intent: 'Under-cabinet lighting kits', quantity: 1 },
      { intent: 'Light switches / dimmers', quantity: 1 },
      { intent: 'LED recessed lights or pendant fixtures', quantity: 1 },
      { intent: 'NM cable (Romex 12/2 or 14/2)', quantity: 1 },
      { intent: 'Electrical boxes (remodel or new work)', quantity: 1 },
      { intent: 'Wire nuts', quantity: 1 },
      { intent: 'Range hood wiring hookup materials', quantity: 1 }
    ]
  },
  {
    groupName: 'Framing & Subfloor Materials',
    materials: [
      { intent: 'Dimensional lumber', quantity: 1 },
      { intent: 'Plywood or OSB (for subfloor repair)', quantity: 1 }
    ]
  },
  {
    groupName: 'Wall & Ceiling Board',
    materials: [
      { intent: 'Drywall (standard and moisture-resistant for sink areas)', quantity: 1 },
      { intent: 'Corner bead', quantity: 1 },
      { intent: 'Insulation (if opening exterior walls)', quantity: 1 }
    ]
  },
  {
    groupName: 'Flooring Materials',
    materials: [
      { intent: 'Flooring (Tile, LVP, hardwood, or laminate)', quantity: 1 },
      { intent: 'Underlayment (if required for flooring type)', quantity: 1 },
      { intent: 'Floor leveling compound (if needed)', quantity: 1 },
      { intent: 'Transition thresholds', quantity: 1 }
    ]
  },
  {
    groupName: 'Cabinets & Countertops',
    materials: [
      { intent: 'Base and wall cabinets (including panels, fillers, toe kicks)', quantity: 1 },
      { intent: 'Crown molding (if applicable)', quantity: 1 },
      { intent: 'Cabinet hardware (pulls, knobs, hinges if not pre-installed)', quantity: 1 },
      { intent: 'Soft close hardware', quantity: 1 },
      { intent: 'Countertops (stone, laminate, quartz, etc.)', quantity: 1 },
      { intent: 'Backsplash tile', quantity: 1 },
      { intent: 'Backerboard', quantity: 1 },
      { intent: 'Backsplash mortar/thinset', quantity: 1 },
      { intent: 'Backsplash grout', quantity: 1 }
    ]
  },
  {
    groupName: 'Fixtures & Appliances',
    materials: [
      { intent: 'Kitchen sink (single, double, or workstation)', quantity: 1 },
      { intent: 'Kitchen faucet (with sprayer or pull-down feature)', quantity: 1 },
      { intent: 'Garbage disposal', quantity: 1 },
      { intent: 'Dishwasher', quantity: 1 },
      { intent: 'Range or cooktop', quantity: 1 },
      { intent: 'Range hood or microwave hood', quantity: 1 },
      { intent: 'Wall oven (if separate)', quantity: 1 },
      { intent: 'Refrigerator', quantity: 1 },
      { intent: 'Ice maker hookup kit (if applicable)', quantity: 1 },
      { intent: 'Water line kit (for fridge)', quantity: 1 },
      { intent: 'Range hood exhaust ducting', quantity: 1 }
    ]
  },
  {
    groupName: 'Paint & Trim Materials',
    materials: [
      { intent: 'Mold/moisture-resistant primer', quantity: 1 },
      { intent: 'Kitchen-grade paint', quantity: 1 },
      { intent: 'Baseboards and crown molding', quantity: 1 }
    ]
  },
  {
    groupName: 'Loadout List - Double Check Your Stock',
    materials: [
      { intent: 'Silicone sealant / plumber\'s putty', quantity: 1 },
      { intent: 'Pipe insulation (if required by code)', quantity: 1 },
      { intent: 'Electrical tape', quantity: 1 },
      { intent: 'Cable Staples', quantity: 1 },
      { intent: 'Blocking material for cabinet support', quantity: 1 },
      { intent: 'Construction adhesive', quantity: 1 },
      { intent: 'Construction Screws', quantity: 1 },
      { intent: 'Flooring Nails', quantity: 1 },
      { intent: 'Shims', quantity: 1 },
      { intent: 'Drywall joint compound & tape', quantity: 1 },
      { intent: 'Sanding paper blocks', quantity: 1 },
      { intent: 'Adhesive or mortar (depending on flooring system)', quantity: 1 },
      { intent: 'Grout for tile floors', quantity: 1 },
      { intent: 'Sealer for tile floors', quantity: 1 },
      { intent: 'Adhesive or mounting hardware', quantity: 1 },
      { intent: 'Cabinet screws', quantity: 1 },
      { intent: 'Brad nails', quantity: 1 },
      { intent: 'Caulk (paintable and silicone for wet areas)', quantity: 1 },
      { intent: 'Brushes', quantity: 1 },
      { intent: 'Roller replacements', quantity: 1 },
      { intent: 'Paint tray replacements', quantity: 1 },
      { intent: 'Painters tape (if desired)', quantity: 1 },
      { intent: 'Drop cloths', quantity: 1 },
      { intent: 'Shop vac filters', quantity: 1 },
      { intent: 'Rags', quantity: 1 },
      { intent: 'Cleaners', quantity: 1 },
      { intent: 'Touch-up kits (paint, filler, stain pens)', quantity: 1 }
    ]
  }
];
